import { APIModel } from './ApiTypes';
import { FileField } from './ApiTypes';

export class User extends APIModel {
  static API = '/api/users/';
  username!: string;
  email!: string;
  password?: string;
  is_admin?: boolean;
  profile_image?: FileField;
  created_at?: string;
  updated_at?: string;
}